// src/components/MessageBubble.tsx
import { useState } from 'react';
import type { Message } from '../types';
import styles from './MessageBubble.module.css';

interface Props {
  message: Message;
  onRate: (msgId: string, pointId: string, rating: 1 | -1) => void;
}

export function MessageBubble({ message, onRate }: Props) {
  const [showMem,    setShowMem]    = useState(false);
  const [showReason, setShowReason] = useState(false);

  const isUser    = message.role === 'user';
  const isSupport = message.isSupport;

  const time = new Date(message.timestamp).toLocaleTimeString([], {
    hour: '2-digit', minute: '2-digit',
  });

  return (
    <div className={`${styles.wrap} ${isUser ? styles.user : styles.assistant}`}>
      {/* Avatar */}
      {!isUser && (
        <div className={`${styles.avatar} ${isSupport ? styles.supportAvatar : ''}`}>
          P
        </div>
      )}

      <div className={styles.right}>
        {/* Bubble */}
        <div className={`${styles.bubble} ${isUser ? styles.userBubble : ''} ${isSupport ? styles.supportBubble : ''}`}>
          {message.content}
        </div>

        {/* Meta */}
        <div className={`${styles.meta} ${isUser ? styles.metaRight : ''}`}>
          {time}
          {isSupport && <span className={styles.tag}>support</span>}
        </div>

        {/* Expanders — assistant only */}
        {!isUser && (
          <div className={styles.expanders}>
            {/* Memories */}
            {(message.memories?.length ?? 0) > 0 && (
              <div>
                <button
                  className={styles.expandBtn}
                  onClick={() => setShowMem(v => !v)}
                >
                  📎 {message.memories!.length} memories {showMem ? '▲' : '▼'}
                </button>
                {showMem && (
                  <div className={styles.expandBody}>
                    <div className={styles.expandLabel}>Retrieved from Qdrant:</div>
                    {message.memories!.map((m, i) => (
                      <div key={i} className={styles.memItem}>
                        {(m.content || '').substring(0, 200)}
                        {(m.content || '').length > 200 ? '…' : ''}
                      </div>
                    ))}
                  </div>
                )}
              </div>
            )}

            {/* Reasoning */}
            {message.reasoning && (
              <div>
                <button
                  className={styles.expandBtn}
                  onClick={() => setShowReason(v => !v)}
                >
                  🧠 Persona reasoning {showReason ? '▲' : '▼'}
                </button>
                {showReason && (
                  <div className={styles.expandBody}>
                    <div className={styles.expandLabel}>Character reasoning:</div>
                    {message.reasoning}
                  </div>
                )}
              </div>
            )}

            {/* Feedback */}
            {!isSupport && message.point_id && (
              <div className={styles.feedbackRow}>
                <span className={styles.feedbackLabel}>helpful?</span>
                {message.feedback === 1 ? (
                  <span className={`${styles.fbTag} ${styles.fbUp}`}>👍 rated helpful</span>
                ) : message.feedback === -1 ? (
                  <span className={`${styles.fbTag} ${styles.fbDown}`}>👎 rated unhelpful</span>
                ) : (
                  <>
                    <button
                      className={styles.fbBtn}
                      onClick={() => onRate(message.id, message.point_id!, 1)}
                    >👍</button>
                    <button
                      className={styles.fbBtn}
                      onClick={() => onRate(message.id, message.point_id!, -1)}
                    >👎</button>
                  </>
                )}
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
